import * as z from "zod";

export const getSegmentProducts = {
  name: "getSegmentProducts" as const,
  description: "Products this store has, for a product condition's values.",
  mutates: false,
  input: z.null(),
  output: z.array(
    z.object({ id: z.string(), handle: z.string(), title: z.string() }),
  ),
};
